import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Icon from '../AppIcon';

const DemoGuard = ({ children, redirectTo = '/dashboard' }) => {
  const { isDemoMode } = useAuth();
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (isDemoMode) {
      setShowBanner(true);
      const timer = setTimeout(() => {
        setShowBanner(false);
        navigate(redirectTo, { replace: true });
      }, 2500);
      return () => clearTimeout(timer);
    }
  }, [isDemoMode, navigate, redirectTo]);

  if (isDemoMode) {
    return (
      <>
        {showBanner && (
          <div className="fixed top-6 left-1/2 -translate-x-1/2 z-[9999] flex items-center gap-3 bg-[#1a2332] text-white px-5 py-3 rounded-xl shadow-2xl border border-white/10 animate-fade-in">
            <Icon name="Lock" size={18} className="text-orange-400 flex-shrink-0" />
            <span className="text-sm font-medium">Settings are not available in demo mode.</span>
          </div>
        )}
      </>
    );
  }

  return children;
};

export default DemoGuard;
